import { Button, Dialog, Alert, Typography, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function GuideVerifyDialog(props: any) {
  const { setLoading, openDialog, setOpenDialog, loadList, guideId, guideCode, currentVerified } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [verified, setVerified] = useState<number>(0);

  useEffect(() => {
    if (openDialog) {
      setVerified(currentVerified || 0);
    }
  }, [openDialog, currentVerified]);

  const handleSubmit = async () => {
    if (!guideId) {
      enqueueSnackbar("Error: ID de guía no disponible", { variant: "error" });
      return;
    }

    setLoading(true);

    await ApiRequest({
      url: "/guides/verifyGuide",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        guide_id: guideId,
        verified: verified,
      }),
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Estado de verificación actualizado", { variant: "success" });
          setOpenDialog(false);
          loadList();
        } else {
          enqueueSnackbar(response.message || "Error al actualizar", { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={{ p: 3 }}>
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Verificación de guía</h2>
            <span className="h2_subtitle">Cambiar estado de verificación</span>
          </div>
        </div>

        <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold">
            Guía: {guideCode}
          </Typography>
          <Typography variant="body2">
            Estado actual: {currentVerified === 1 ? 'Verificado' : 'No verificado'}
          </Typography>
        </Alert>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="verified-select-label">Estado de verificación</InputLabel>
          <Select
            labelId="verified-select-label"
            id="verified-select"
            value={verified}
            label="Estado de verificación"
            onChange={(e) => setVerified(Number(e.target.value))}
          >
            <MenuItem value={0}>No verificado</MenuItem>
            <MenuItem value={1}>Verificado</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Guardar
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
